export type ScheduleHorizon = "all_dates" | "next_1_week" | "next_2_weeks" | "next_3_weeks" | "next_1_month"

export interface ScheduleHorizonOption {
    value: ScheduleHorizon
    label: string
    /** Length of the window in days, counted from the start of today. `null` means no bound. */
    days: number | null
}

export const SCHEDULE_HORIZON_OPTIONS: ScheduleHorizonOption[] = [
    { value: "all_dates", label: "All dates", days: null },
    { value: "next_1_week", label: "Next 1 week", days: 7 },
    { value: "next_2_weeks", label: "Next 2 weeks", days: 14 },
    { value: "next_3_weeks", label: "Next 3 weeks", days: 21 },
    { value: "next_1_month", label: "Next 1 month", days: 30 },
]
